/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  withStyles,
} from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';
import { Alert } from '@material-ui/lab';
import { startChatWithContact } from '@src/actions/agentconsole';
import TemplatedMsgBackendProxy from '@src/logic/TemplatedMsgBackendProxy';
import {
  MessagingProviderSmallIcon20,
  isNoOffWappMsgProvider,
  isWappMsgProvider,
  isWhatsAppOffMsgProvider,
} from '@src/model/frontendmodel';
import StringUtils from '@src/utils/strings';
import { MobileNumberValidator } from '@src/utils/validation';
import _ from 'lodash';
import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SelectTemplate from '../../Template/SelectTemplate';
import { TemplateType } from '../Channels/WhatsApp/WhatsAppTemplates/types';
import './StartChatWithContactDialog.css';

class StartChatWithContactDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAccountData: null,
      templatedMsgs: [],
      selectedTemplate: null,
      showTemplateList: false,
      warningMsg: null,
      disableStartBtn: false,
    };

    this.handleSelectBotMsgAccount = this.handleSelectBotMsgAccount.bind(this);
    this.handleStartChat = this.handleStartChat.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleSelectBotMsgAccount(accountData) {
    let mobileNumberValid = true;

    if (isNoOffWappMsgProvider(accountData.provider)) {
      mobileNumberValid = MobileNumberValidator.isValidForCountry(
        this.props.merchantCountry.isoCode,
        this.props.openWithContact.mobileNumber
      );
    }

    if (isWhatsAppOffMsgProvider(accountData.provider)) {
      TemplatedMsgBackendProxy.getByBotAccountId(
        accountData.botAccountId,
        this.props.openWithContact.id
      ).then(httpResponse => {
        if (httpResponse.status === 200) {
          httpResponse.json().then(templatedMsgs => {
            console.debug('templated msg', templatedMsgs);

            const defaultTemplates = templatedMsgs.filter(
              templateWrapper => templateWrapper.templatedMsg.byDefault
            );
            const templatesWithoutCallType = templatedMsgs.filter(
              template =>
                !template.templatedMsg.templateComponent?.some(
                  button => button?.type === TemplateType.CALL_PERMISSION
                )
            );

            const initialTemplate =
              defaultTemplates.length > 0
                ? defaultTemplates[0]
                : templatedMsgs[0];

            // Sort templates by name, alphabetically
            if (!_.isNil(templatedMsgs)) {
              templatedMsgs.sort((a, b) => {
                const nameA = _.get(a, 'templatedMsg.name', '');
                const nameB = _.get(b, 'templatedMsg.name', '');

                return nameA.localeCompare(nameB);
              });
            }

            this.setState({
              templatedMsgs: templatesWithoutCallType,
              selectedTemplate: initialTemplate,
              disableStartBtn: false,
            });
          });
        } else if (httpResponse.status === 404) {
          this.setState({
            templatedMsgs: [],
            selectedTemplate: null,
            disableStartBtn: true,
          });
        }
      });
    } else {
      this.setState({
        templatedMsgs: [],
        selectedTemplate: null,
        disableStartBtn: false,
      });
    }

    this.setState({
      selectedAccountData: accountData,
      selectBotAccountError: false,
      warningMsg: !mobileNumberValid,
    });
  }

  handleStartChat() {
    const accountData = this.state.selectedAccountData;
    const contact = this.props.openWithContact;
    let selectBotAccountError = false;
    const templatedMsgId =
      this.state.selectedTemplate !== null
        ? this.state.selectedTemplate.templatedMsg.id
        : null;

    if (accountData && accountData.botAccount && contact !== null) {
      this.props.onClose();
      // Trigger the start-chat action between the bot msg. account and the contact account selected
      this.props.startChatWithContact(
        accountData.botId,
        accountData.botAccount,
        accountData.provider,
        accountData.contactAccountId,
        contact.id,
        templatedMsgId
      );
    } else {
      selectBotAccountError = true;
    }

    this.setState({
      selectBotAccountError,
    });
  }

  handleCancel() {
    this.props.onClose();
  }

  buildAccountText(curBotMsgAcct, contactAccountChecked) {
    let curAcctName = null;
    const curAcctAlias = StringUtils.trimToEmpty(curBotMsgAcct.botAccountAlias);

    if (curAcctAlias === '') {
      curAcctName = `${curBotMsgAcct.botAccount}@${curBotMsgAcct.provider}`;
    } else {
      curAcctName = `(${curAcctAlias}) ${curBotMsgAcct.botAccount}@${curBotMsgAcct.provider}`;
    }

    const providerLogoStyle = {
      width: '17px',
      height: '17px',
      marginRight: '13px',
    };
    let logoId = 'defaultId';
    let logSrc = null;

    if (curBotMsgAcct.botAccountIconUrl) {
      logSrc = curBotMsgAcct.botAccountIconUrl;
    } else {
      logSrc = MessagingProviderSmallIcon20[curBotMsgAcct.provider];
    }

    let companionTxt = null;

    if (isWappMsgProvider(curBotMsgAcct.provider)) {
      if (contactAccountChecked) {
        logoId = 'wappGreenLogo';

        if (curBotMsgAcct.botStatus === 'SUSPENDEDB2CHAT') {
          companionTxt = (
            <FormattedMessage id="Contact.startChatDialog.itemDisabledTemporarily" />
          );
        }
      } else {
        companionTxt = (
          <span style={{ marginLeft: '5px' }}>
            <Warning
              style={{ marginRight: '5px', width: '15px', height: '15px' }}
            />
            <FormattedMessage id="Contact.startChatDialog.contactNoWappAccount" />
          </span>
        );
      }
    }

    return (
      <Box display="flex" alignItems="center">
        <img id={logoId} style={providerLogoStyle} src={logSrc} alt="" />
        <span>{curAcctName} </span>
        {companionTxt}
      </Box>
    );
  }

  onShowTemplates = () => {
    this.setState(state => ({
      ...state,
      showTemplateList: !state.showTemplateList,
    }));
  };

  onSelectedTemplate = templateId => {
    const { templatedMsgs } = this.state;
    let newSelTemplate = null;

    templatedMsgs.map(tm => {
      if (tm.templatedMsg.id === templateId) newSelTemplate = { ...tm };
      return tm;
    });

    if (newSelTemplate)
      this.setState(state => ({
        ...state,
        showTemplateList: !state.showTemplateList,
        selectedTemplate: newSelTemplate,
      }));
  };

  buildDialog = () => {
    let arrBotMsgAccounts = null;
    const {
      showTemplateList,
      templatedMsgs,
      selectedTemplate,
      disableStartBtn,
      selectedAccountData,
      selectBotAccountError,
      warningMsg,
    } = this.state;
    const { botMsgAccounts, accountChecked, openWithContact, classes } =
      this.props;

    // Build options for the select field, with each bot msg. account that can be used to chat with the contact
    if (botMsgAccounts && accountChecked !== null) {
      arrBotMsgAccounts = [];
      let curBotMsgAcct = null;

      for (let i = 0; i < botMsgAccounts.length; i += 1) {
        curBotMsgAcct = botMsgAccounts[i];

        const accountItemText = this.buildAccountText(
          curBotMsgAcct,
          accountChecked
        );

        arrBotMsgAccounts.push(
          <MenuItem
            key={i}
            value={curBotMsgAcct}
            className="muiMenuItem"
            disabled={
              curBotMsgAcct.botStatus !== null &&
              curBotMsgAcct.botStatus === 'SUSPENDEDB2CHAT'
            }
          >
            {accountItemText}
          </MenuItem>
        );
      }
    }

    const arrActionBtns = [];

    let dialogContent = null;

    if (arrBotMsgAccounts === null || accountChecked === null) {
      dialogContent = (
        <div>
          <FormattedMessage id="Contact.startChatDialog.checkingAccounts" />
        </div>
      );
    } else {
      arrActionBtns.push(
        <Button
          color="primary"
          variant="contained"
          onClick={this.handleStartChat}
          style={{ marginRight: '1.0em' }}
          disabled={!this.state.selectedAccountData || disableStartBtn}
          data-testid="start-chat-submit"
          fullWidth
        >
          <FormattedMessage id="Contact.startChatDialog.startChatButton" />
        </Button>
      );

      dialogContent = (
        <div className={showTemplateList ? 'dl-content' : ''}>
          {arrBotMsgAccounts.length > 0 ? (
            <>
              <Box my={2}>
                <TextField
                  select
                  fullWidth
                  id="botAccount"
                  data-testid="start-chat-line-select"
                  value={selectedAccountData}
                  label={
                    <FormattedMessage id="Contact.startChatDialog.selectBotAccountLabel" />
                  }
                  onChange={({ target }) =>
                    this.handleSelectBotMsgAccount(target.value)
                  }
                  error={selectBotAccountError}
                  helperText={
                    selectBotAccountError && (
                      <FormattedMessage id="Contact.startChatDialog.selectAccountError" />
                    )
                  }
                  disabled={showTemplateList}
                >
                  {arrBotMsgAccounts}
                </TextField>
              </Box>
              {warningMsg && (
                <Alert severity="warning">
                  <FormattedMessage id="Contact.startChatDialog.badFormat" />
                </Alert>
              )}

              {disableStartBtn && (
                <Alert severity="info">
                  <FormattedMessage id="TemplatedMsg.templateNoAvailable" />
                </Alert>
              )}
            </>
          ) : (
            <Box my={2}>
              <Alert severity="info">
                <FormattedMessage id="Contact.startChatDialog.noAccount" />
              </Alert>
            </Box>
          )}

          <SelectTemplate
            onSelectedTemplate={this.onSelectedTemplate}
            selectedTemplate={selectedTemplate}
            templatedMsgs={templatedMsgs}
            showTemplates={showTemplateList}
            onShowTemplates={this.onShowTemplates}
            allowClass={false}
          />
        </div>
      );
    }

    return (
      <Dialog
        open
        onClose={this.handleCancel}
        classes={{
          paper: classes.paper,
        }}
      >
        <DialogTitle>
          <Box className={classes.contactTitle}>
            <FormattedMessage id="Contact.startChatDialog.contact.label" />:{' '}
            {openWithContact.fullName} | {openWithContact.mobileNumber}
          </Box>
          <Box
            style={{
              fontFamily: 'Poppins',
              fontWeight: 600,
              fontStyle: 'SemiBold',
              fontSize: '16px',
            }}
          >
            <FormattedMessage id="Contact.startChatDialog.title" />
          </Box>
          <Box
            style={{
              fontWeight: 300,
              fontSize: '12px',
              paddingTop: '8px',
            }}
          >
            <FormattedMessage id="Contact.startChatDialog.chooseBotAccountInfo" />
          </Box>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>{dialogContent}</DialogContent>
        <DialogActions>{arrActionBtns}</DialogActions>
      </Dialog>
    );
  };

  render() {
    return <div>{this.buildDialog()}</div>;
  }
}

// Map Redux state to properties of the StartChatWithContactDialog component
const mapStateToProps = state => ({
  botMsgAccounts:
    state.adminHome.contact.contacts.conversation.availableMessaginAccount,
  merchantCountry: state.loginAuthentication.success.employer.country,
});

// Maps the action creators to a set of props that will be passed as functions to the presentational component
const mapDispatchToProps = {
  startChatWithContact,
};

const StartChatWithContactDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    injectIntl(
      withStyles(theme => ({
        contactTitle: {
          fontWeight: 500,
          fontStyle: 'Medium',
          fontSize: '14px',
          leadingTrim: 'NONE',
          lineHeight: '140%',
          letterSpacing: '0%',
          verticalAlign: 'middle',
          color: theme.palette.primary.main,
          paddingBottom: '8px',
        },
        paper: {
          borderRadius: '8px',
          border: `3px solid ${theme.palette.primary.main}`,
        },
      }))(StartChatWithContactDialog)
    )
  )
);

export default StartChatWithContactDialogContainer;
